// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/fancy-landing/actions-circles.svg';
import { sxAppend } from '@rhg/libs/material/sx';

// This SVG's own un-filled shapes rely on inheriting the root <svg>'s own
// `fill="none"` attribute, rather than setting their own fill - but
// MuiSvgIcon overrides that root fill to `currentColor` via CSS whenever
// it's given a `component` (its `hasSvgAsChild` check only recognizes a
// literal `<svg>` passed as children, not this usage), which beats the
// attribute. Restoring `fill: none` here keeps those shapes rendering
// empty as designed, instead of solid.
const styleFillNone = { fill: 'none' };

// `inheritViewBox` should read this size straight off the underlying `Svg`
// component instead of it being hardcoded here - but in practice, the
// installed `@svgr/webpack` pipeline strips the source file's own
// `viewBox` attribute during compilation (verified directly in the
// compiled dev bundle - present on disk, gone from the built component),
// so `inheritViewBox` has nothing to inherit and this SVG renders unscaled
// at its native 360x360 canvas at any other rendered size, clipping
// instead of scaling. Passing `viewBox` explicitly bypasses that entirely.
const VIEW_BOX = '0 0 360 360';

export const ActionsCircles = ({ sx, ...props }: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        viewBox={VIEW_BOX}
        sx={sxAppend(styleFillNone, sx)}
        {...props}
    />
);
